import React from "react";
import {
  CircularProgress,
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from "@mui/material";
import styles from "./Button.module.scss";

interface Props extends MuiButtonProps {
  text: string;
  onClick?: () => void;
  isLoading?:boolean;
  type?:"button" | "submit" | "reset";
  disabled?:boolean;
}

const Button: React.FC<Props> = ({
  text,
  onClick,
  isLoading,
  type = "button",
  disabled = false,
  ...muiProps
}) => {
  return (
    <MuiButton
      {...muiProps}
      onClick={onClick}
      type={type}
      className={styles.gradientButton}
      sx={{
        width: "inherit",
        fontSize: `calc(16px * var(--dynamic-font-size, 1)) !important`,
        boxShadow:"none", 
        ...muiProps.sx,
      }}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <CircularProgress
          size={18}
          style={{
            color: "#fff",
          }}
        />
      ) : (
        text
      )}
    </MuiButton>
  );
};

export default Button;
